import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E88B06D9-C60D-4084-9AE9-742266F0E8FB
 * name white-balance-iridescent
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/white-balance-iridescent.svg
 * tags
 * - Photography 
 */
export const WhiteBalanceIridescentIcon = createSvgIcon(<><path d="M4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53M3.55,4.46L5.34,6.26L6.76,4.84L4.96,3.05M20.45,18.53L18.66,16.74L17.24,18.15L19.04,19.95M13,22.45V19.5H11V22.45C11.32,22.45 13,22.45 13,22.45M19.04,3.05L17.24,4.84L18.66,6.26L20.45,4.46M11,3.5H13V0.55H11M5,14.5H19V8.5H5V14.5Z" /></>, 'WhiteBalanceIridescentIcon');
export default WhiteBalanceIridescentIcon